import Vue from 'vue'
const vueCore = Vue.prototype
let wechatRegisterHref = ''
/*
 * 注册微信开放api
 */
const registerWechatApi = function () {
	var href = ''
	var device = navigator.userAgent.toLowerCase()
	if (/iphone|ipad|ipod/.test(device)) {
		href = wechatRegisterHref
	} else if (/android/.test(device)) {
		href = window.location.href
	}
	var params = {
		url: href
	}
	Vue.http.post('/cldEdi/api/apiTicket', params).then((response) => {
		var data = response.body
		if (!data.result) {
			vueCore.$fxToast.warning(data.message)
		} else {
			setWechatConfig(data.data)
		}
	}, (response) => {
		vueCore.$fxToast.netError('网络异常')
	})
}
const setWechatConfig = function (data) {
	window.wx.config({
		debug: false,
		appId: data.appId,
		timestamp: data.timestamp,
		nonceStr: data.nonceStr,
		signature: data.signature,
		jsApiList: [
			'scanQRCode',
			'chooseImage',
			'previewImage',
			'uploadImage',
			'downloadImage',
			'getLocation'
		],
		openTagList: [
			'wx-open-launch-weapp'
		]
	})
	window.wx.error((res) => {
		window.console.log('配置错误')
		window.console.log(res)
	})

	// document.addEventListener('WeixinOpenTagsError', function (e) {
	// 	console.log('无法使用微信tag', e)
	// 	console.error(e.detail.errMsg)
	// })
}

const createWechatRegisterHref = function () {
	wechatRegisterHref = window.location.href
}

export default {
	registerWechatApi,
	createWechatRegisterHref
}



// WEBPACK FOOTER //
// ./src/lib/weixin/src/register.js